import { Alert, LoadingSpinner, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { BadDebtCategory } from "@oysterhr/schema"
import { CompanyPaymentStatusBadge } from "../../CompanyPaymentStatusBadge"
import { IconWithTooltip } from "@oysterhr/feature-components"
import { PaymentStatusLabelsMap } from "../../../constants/paymentStatus"
import { StaffInvoicingBadDebtCompanyUnpaidInvoicesQuery } from "../../../gql/graphql"

interface Props {
  unpaidInvoicesAmount?: NonNullable<
    StaffInvoicingBadDebtCompanyUnpaidInvoicesQuery["company"]
  >["customer"]["unpaidInvoicesAmount"]
  badDebtCategory?: BadDebtCategory | null
}

export const PaymentStatusSection = ({ unpaidInvoicesAmount, badDebtCategory }: Props) => {
  const { t } = useTranslation("invoices/CompanyPaymentStatusSection")

  return (
    <div className="space-y-2">
      <Text size="small" className="font-semibold">
        {t("customerRestrictionModal.customerPaymentStatus")}
      </Text>
      {badDebtCategory && (
        <div className="grid gap-1">
          <div>
            <CompanyPaymentStatusBadge state={badDebtCategory} />
          </div>
          <Text className="text-gray-400">
            {t(`customerPaymentStatus.${PaymentStatusLabelsMap[badDebtCategory].descriptionKey}`)}
          </Text>
        </div>
      )}
      {unpaidInvoicesAmount ? (
        <div className="grid gap-2 rounded-md border border-gray-200 bg-gray-100 px-4 py-3">
          <Text size="small" className="font-semibold">
            {t("customerRestrictionModal.paymentStatusDetailsCard.title")}
          </Text>
          <div className="flex justify-between">
            <Text className="text-gray-400">
              {t("customerRestrictionModal.paymentStatusDetailsCard.outstandingAmount")}
            </Text>
            <Text className="font-semibold">{unpaidInvoicesAmount.totalAmount?.formatted}</Text>
          </div>
          <div className="flex justify-between">
            <Text className="flex gap-1 text-gray-400">
              {t("customerRestrictionModal.paymentStatusDetailsCard.outstandingNumberOfDays")}
              <IconWithTooltip
                size="xs"
                value={t(
                  "customerRestrictionModal.paymentStatusDetailsCard.outstandingNumberOfDaysTooltip",
                )}
              />
            </Text>
            <Text className="font-semibold">
              {t("customerRestrictionModal.paymentStatusDetailsCard.outstandingNumberOfDaysValue", {
                count: unpaidInvoicesAmount.averageDueDays,
              })}
            </Text>
          </div>
        </div>
      ) : (
        <div className="flex justify-center">
          <LoadingSpinner />
        </div>
      )}
      <Alert variation="info">
        <Alert.Icon />
        <Alert.Content>{t("customerRestrictionModal.creditNoteAlert")}</Alert.Content>
      </Alert>
    </div>
  )
}
